import cookies from 'browser-cookies';

const hostname = document.location.hostname;
const domain = hostname ? hostname.split('.').slice(-2).join('.') : '';


export const setAuthData = (token) => {
  if (!token) return;

  cookies.set('auth.token', token, { domain, expires: 365 });
}

export const deleteAuthData = () => {
  cookies.erase('auth.token', { domain });
}
